import GlobalQuickMenu from '.';
import useQuickMenu from './useQuickMenu';

const GlobalQuickMenuWrapper = () => {
  const { quickMenu, closeQuickMenu, setQuickMenu } = useQuickMenu();

  if (!quickMenu) {
    return null;
  }

  return (
    <GlobalQuickMenu
      options={quickMenu}
      closeQuickMenu={closeQuickMenu}
      setQuickMenu={setQuickMenu}
    />
  );
};

export default GlobalQuickMenuWrapper;
